<google-map [width]="width" [height]="height" [center]="position" [zoom]="zoom">
  <map-marker [position]="position"></map-marker>
</google-map>
